
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/NewsSubLandingPage",
      function () {
        return require("private-next-pages/landingPages/NewsSubLandingPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/NewsSubLandingPage"])
      });
    }
  